import Carousel from '../modules/carousel'

$.fn.Gallery = function() {
  let self = $(this)
  self.carousel = undefined
  self.el = {
    swiper: self.find('.gallery__swiper'),
    nextEl: self.find('.gallery__button-next'),
    prevEl: self.find('.gallery__button-prev'),
    pagination: self.find('.gallery__pagination'),
  }
  self.pictureHeight = 0

  /* Create carousel */
  self.create_carousel = function() {
    self.carousel = new Carousel(self.el.swiper.get(0), {
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: self.el.nextEl.get(0),
        prevEl: self.el.prevEl.get(0),
      },
      pagination: {
        el: self.el.pagination.get(0),
        type: 'fraction',
      },
    })
    self.carousel.init()
  }

  /* Height alignments */
  self.set_position = function() {
    let rem_base = parseInt($('body').css('font-size')),
    target_height = self.find('.gallery__picture:eq(0)').outerHeight(false)

    if ($.mlmi.mobile.isMobile) {
      self.el.pagination.css('top', Math.floor(target_height + 28 * rem_base / 20))
      self.el.prevEl.css('top', Math.floor(target_height + 44 * rem_base / 20))
      self.el.nextEl.css('top', Math.floor(target_height + 44 * rem_base / 20))
    } else {
      self.el.pagination.css('top', Math.floor(target_height + 48 * rem_base / 20))
      self.el.prevEl.css('top', Math.floor(target_height / 2))
      self.el.nextEl.css('top', Math.floor(target_height / 2))
    }
  }

  return function() {
    self.create_carousel()
    self.set_position()
    $(window).on('load orientationchange resize', function() {
      requestAnimationFrame(self.set_position)
    })
    return self
  }()
}
